const DateUtil = require("@/appUtils/DateUtil")
const NoticeModel = require("@/appModel/Notice/NoticeModel") 

class DashboardNavbarViewModel {
  constructor(tenantId, userSub) {
    this.tenantId = tenantId
    this.scheduledList = []
    this.instantList = []
    this.noticeList = []
    this.userSub = userSub
  }

  static async init(tenantId, userSub) {
    let vm = new DashboardNavbarViewModel(tenantId, userSub)  
    return vm
  }
  

  /**
   * 1週間前までの通知を取得
   */
  async getNoticeList() {
    // 自身宛に送信された3日前までのメッセージを取得
    const filterValue = `notice#${this.userSub}#${DateUtil.getAddDay(-3, 'YYYYMMDD')}000000000`
    // フィルター条件を作成
    const condition = { ge: filterValue}
    // LsiStr2で検索
    const list = await NoticeModel.getNoticeListLsiStr2(condition, this.tenantId, 10, "ASC")
    // ミーティングの通知は排除
    this.noticeList = list.filter((item)=> {
      return item.notice.type == "2"
    });
  }
}
module.exports = DashboardNavbarViewModel;